import {
  VfxErodingBillboardBatchBase,
  VfxErodingBillboardAdditiveBatch,
  VfxErodingBillboardNormalBatch,
  ErodingBillboardLayout,
} from "../../../core/batches/vfx_eroding_billboard_batch.js";

export const FireworkTrailLayout = ErodingBillboardLayout;

export abstract class VfxFireworkTrailBatchBase extends VfxErodingBillboardBatchBase {}

export class VfxFireworkTrailAdditiveBatch extends VfxErodingBillboardAdditiveBatch {}

export class VfxFireworkTrailNormalBatch extends VfxErodingBillboardNormalBatch {}

